import {
    HttpResponse,
    RoleModel,
    QueryModel,
    RequestParams,
    RoleModelIEnumerableApiResultSuccess,
    RoleModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";
import {CrudPartialUpdatePatch} from '@/libs/core/+state/models/crud-partial-update-patch';

export class RolesDataService implements CrudService<RoleModel, RoleModel> {
    getAll(query: CrudDataQuery<RoleModel>): Promise<CrudEnumerableResponse<RoleModel>> {
        return ApiService.api.getRoleBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<RoleModel>): Promise<CrudEnumerableResponse<RoleModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<RoleModel>> {
        return ApiService.api.getRoleById(id, params);
    }

    create(item: RoleModel, params?: RequestParams): Promise<CrudResponse<RoleModel>> {
        return ApiService.api.insertRole(item, params);
    }

    update(item: RoleModel, params?: RequestParams): Promise<RoleModel> {
        return ApiService.api.updateRole(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<RoleModel> {
        return ApiService.api.patchRole(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<RoleModel>): Promise<CrudEnumerableResponse<RoleModel>> {
        return ApiService.api.deleteRoles(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationRole(query, params).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<RoleModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: RoleModel, params?: RequestParams): Promise<CrudResponse<RoleModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getRoleGroupped(query, params);
    }

}
